import axios from 'axios';
//const API_BASE_URL = 'https://localhost:44495';
//const API_BASE_URL = 'http://3.108.215.54:8080';
const API_BASE_URL = 'https://eauctionspicesboard.in';

export default axios.create({
    baseUrl: API_BASE_URL
});

export const axiosPrivate = axios.create({
    baseUrl: API_BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
});